export const colors = {
  white: "#FFFFFF",
  black: "#000000",
  primary: "#345A4B",
  secondary: "#D8A080",
  text: {
    dark: "#1F2221",
    light: "#636363",
    disabled: "#BFBFBF",
    white: "#FFFFFF",
  },
  p1: {
    50: "#E7EBE9",
    100: "#C2CEC9",
    200: "#9AADA5",
    300: "#718C81",
    400: "#527366",
    500: "#345A4B",
    600: "#2F5244",
    700: "#27483B",
    800: "#213F33",
    900: "#152E23",
  },
  p2: {
    50: "#FAF4F0",
    100: "#F3E3D9",
    200: "#ECD0C0",
    300: "#E4BDA6",
    400: "#DEAE93",
    500: "#D8A080",
    600: "#D49878",
    700: "#CE8E6D",
    800: "#C88463",
    900: "#BF7350",
  },
  neutrals: {
    n30: "#F8F8F8",
    n60: "#F2F2F2",
    n80: "#EDEEEE",
    n100: "#E9E9E9",
    n150: "#DEDEDE",
    n200: "#D2D3D3",
    n250: "#C7C7C7",
    n300: "#BCBDBD",
    n350: "#B1B2B2",
    n400: "#A5A7A6",
    n450: "#9A9B9B",
    n500: "#8F9190",
    n550: "#848685",
    n600: "#797A7A",
    n650: "#6D6F6E",
    n700: "#636564",
    n750: "#575959",
    n800: "#4C4E4D",
    n850: "#404342",
    n900: "#363938",
    n950: "#2A2D2C",
    n1000: "#1F2221",
  },
  info: {
    50: "#E9F0F7",
    100: "#C8D9EC",
    500: "#477FC0",
    600: "#4077BA",
    700: "#376CB2",
    800: "#2F62AA",
    900: "#204F9C",
  },
  error: {
    50: "#FAE8E8",
    100: "#F3C6C6",
    500: "#D64242",
    600: "#D13C3C",
    700: "#CC3333",
    800: "#C62B2B",
    900: "#BC1D1D",
  },
  warning: {
    50: "#F8F3E4",
    100: "#ECE2BC",
    500: "#C19E1F",
    600: "#BB961B",
    700: "#B38C17",
    800: "#AB8212",
    900: "#9E700A",
  },
  success: {
    50: "#EDF8EB",
    100: "#D2EDCE",
    500: "#69C25B",
    600: "#61BC53",
    700: "#56B449",
    800: "#4CAC40",
    900: "#3B9F2F",
  },
};
